import { useEffect, useRef, useState } from 'react';

function CountUp({ end = 0, duration = 2000 }) {
  const ref = useRef();
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
        }
      },
      { threshold: 0.6 } // trigger when 60% in view
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [hasAnimated]);

  useEffect(() => {
    if (!hasAnimated) return;
  
    const startTime = performance.now();
  
    function update(currentTime) {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const value = Math.floor(progress * end);
      if (ref.current) {
        ref.current.innerText = value.toLocaleString() + (end >= 4 ? '+' : '');
      }
      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }
  
    requestAnimationFrame(update);
  }, [hasAnimated, end, duration]);

  return <h3 ref={ref}>0</h3>;
}

export default CountUp;
